// Central API base URL — set REACT_APP_API_URL in Vercel environment variables
// e.g. https://your-backend.onrender.com/api
const API_BASE = (process.env.REACT_APP_API_URL || 'http://localhost:4000/api').trim().replace(/\/+$/, '');

export default API_BASE;
